/* eslint-disable no-unneeded-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from '@tvg/fuse-design';
import IconDescription from '@tvg/fuse-icons/lib/Description';
import loadOneWorldSync from 'utilities/oneWorldSync/oneWorldSync-util';
import { OneWorldSyncLoaderInfoProps, OneWorldSyncInlineContentProps } from 'types/OneWorldSyncLoaderTypes';
import {
  AccordionWrapperDiv,
  Container,
  FeaturesContainer,
  LinksContainer,
  StyledAccordion,
  TechSpecsContainer,
  DocsContainer,
} from './InlineContentStyles';
import accordionsProps from './InlineContentProps';

const { descriptionProps, featuresProps, techSpecsProps, documentationProps } = accordionsProps;

function InlineContent(props: OneWorldSyncInlineContentProps) {
  const { brand, mpn, ean, option, Description, AppleContent, LoadBee } = props;
  const docsRef = useRef<HTMLDivElement>(null);
  const [displayFeatures, setFeatures] = useState(false);
  const [displaySpecs, setDisplaySpecs] = useState(false);
  const [displayDocs, setDisplayDocs] = useState(false);

  useEffect(() => {
    if (brand) {
      const loaderInfo: OneWorldSyncLoaderInfoProps = {
        brand,
        window,
        option,
        mpn,
        ean,
      };
      loadOneWorldSync(loaderInfo);
    }
  }, [brand]);

  useEffect(() => {
    const interval = setInterval(() => {
      const featsExist = document.querySelector('[data-testid="oneworldsync-features"]');
      const specsExist = document.querySelector('[data-testid="oneworldsync-combo-spec"]');
      const docsExist = document.querySelector('[data-testid="oneworldsync-documents"]');

      if (featsExist && specsExist && docsExist) {
        setFeatures(featsExist.hasChildNodes());
        setDisplaySpecs(specsExist.hasChildNodes());
        setDisplayDocs(docsExist.hasChildNodes());
      }
    }, 1000);

    // After n seconds stop the initial checking
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    // clean up interval & timeout when component unmounts
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return Description ? (
    <AccordionWrapperDiv>
      <StyledAccordion
        {...descriptionProps}
        open
        children={
          <>
            {Description}
            {AppleContent && AppleContent}
            {LoadBee && LoadBee}
            <Container id="ccs-inline-content" data-testid="oneworldsync-inline-content" />
          </>
        }
      />
      <div style={!displayFeatures ? { display: 'none' } : {}}>
        <StyledAccordion
          {...featuresProps}
          children={<FeaturesContainer id="ccs-features" data-testid="oneworldsync-features" />}
        />
      </div>
      <div style={!displaySpecs ? { display: 'none' } : {}}>
        <StyledAccordion
          {...techSpecsProps}
          children={<TechSpecsContainer id="ccs-combo-spec" data-testid="oneworldsync-combo-spec" />}
        />
      </div>
      <div style={!displayDocs ? { display: 'none' } : {}}>
        <StyledAccordion
          {...documentationProps}
          children={
            <>
              <DocsContainer id="ccs-documents" data-testid="oneworldsync-documents" ref={docsRef} />
              {docsRef.current && docsRef.current.children.length > 0 && (
                <LinksContainer data-testid="oneworldsync-custom-documents">
                  {Array.from(docsRef.current.children).map((el, i) => (
                    <Link
                      dataTestId={`docs-link-${i + 1}`}
                      href={(el.children[0] as any).href}
                      disabled={false}
                      standalone
                      icon={<IconDescription />}
                      target="_blank"
                    >
                      View {(el.children[0] as any).innerText.toLowerCase()}
                    </Link>
                  ))}
                </LinksContainer>
              )}
            </>
          }
        />
      </div>
    </AccordionWrapperDiv>
  ) : (
    <Container id="ccs-inline-content" data-testid="oneworldsync-inline-content" />
  );
}

export default InlineContent;
